const __RELATIVE_SOURCE_FILE__ /* __INJECTED__ */ = 'packages/patapp_web/src/config/uster/eCheckin/sections/EinwArzt.tsx';
import React, { forwardRef } from 'react';
import _ from 'lodash';
import { useText } from '@cistec/common_web/utils/intlUtils';
import { useCIS4m, useCIS4mData } from '@cistec/common_web/modules/CIS4m/hooks';
import textMap from 'App/config/uster/eCheckin/translations';
import { createFieldPath } from 'App/components/eCheckin/utils';
import ECheckinSection from 'App/components/eCheckin/components/ECheckinSection';
import { ECheckinSectionProps } from 'App/components/eCheckin/types';
import { ArztBlock, ArztFieldsConfig } from 'App/components/eCheckin/components/fields/ArztBlock';
import { AddressFieldsConfig } from 'App/components/eCheckin/components/fields/AddressBlock';
import { EinweisenderArztField } from './components/metakat/EinweisenderArzt/EinweisenderArztField';

const addressFieldsConfig: AddressFieldsConfig = {
    additionalInfo: {
        included: false,
    },
    country: {
        included: false,
    },
};
const arztFieldsConfig: ArztFieldsConfig = {
    tel: {
        required: false,
    },
};

export const EinwArtz = forwardRef((props: ECheckinSectionProps, ref: any) => {
    const { path } = props;
    const title = useText(props.title);

    const PATH_ASSIGNMENT = createFieldPath(path, 'assignment');

    const formData = useCIS4mData();

    const assignment = _.get(formData, PATH_ASSIGNMENT);
    const hideDoctorDetails = !['Facharzt/-ärztin'].includes(assignment);

    const eCheckinSectionRef = useCIS4m(ref);

    return (
        <ECheckinSection ref={eCheckinSectionRef} path={path} title={title}>
            <h1>{title}</h1>
            <EinweisenderArztField label={textMap.assignment} path={PATH_ASSIGNMENT} />
            <ArztBlock
                hidden={hideDoctorDetails}
                basePath={path}
                addressFieldsConfig={addressFieldsConfig}
                fieldsConfig={arztFieldsConfig}
                required={true}
            />
        </ECheckinSection>
    );
});

EinwArtz.displayName = 'EinwArtz';

export default EinwArtz;
